<li :id="id"
    class="m-select-item"
    :class="{
        'm--is-focus': isFocused,
        'm--is-selected': selected && isItemActive,
        'm--is-item-active': isItemActive,
        'm--is-disabled': disabled,
        'm--readonly': readonly,
        'm--without-radio': hideRadioButtonMobile
    }"
    role="option"
    :aria-selected="selected && isItemActive"
    @click.prevent="onClick">

    <m-checkbox
        v-if="multiselect && !hideRadioButtonMobile"
        :value="selected"
        :focused="isFocused"
        :disabled="disabled"
        :readonly="readonly"
        position="right"
        style="width: 100%"
    >
        <span class="m-select-item__element-text">
            <slot>{{label}}</slot>
        </span>
    </m-checkbox>

    <span
        v-else-if="isMqMinS || hideRadioButtonMobile"
        class="m-select-item__element-text"
    >
        <slot>{{label}}</slot>
    </span>

    <m-radio-style
        v-else-if="!multiselect"
        :full-width="true"
        radio-position="right"
        :focus="isFocused"
        :checked="selected || isFocused"
        :disabled="disabled"
        :readonly="readonly"
        tabindex="0"
    >
        <span class="m-select-item__element-text">
            <slot>{{label}}</slot>
        </span>
    </m-radio-style>

</li>
